import { StaffApi } from 'helpers';

export const progressDevContractWorkflow = async (
  authToken: string,
  request: unknown
) => {
  await new StaffApi('activities', authToken).post(
    'DevProgressContractWorkflow',
    request
  );
};
